// extracted by mini-css-extract-plugin
export var trademarkShrink = "bertholdTitle-module--trademark-shrink--ff9d3";